import { DepressionCalculatedValues, ElementaryZone } from "@/models/site.model";
import store from "@/store";
import useVuelidate, { Validation } from "@vuelidate/core";
import { Component, Prop, Vue } from "vue-property-decorator";
import ElementaryZoneItem from "./ElementaryZoneItem/index.vue";

@Component({
  components: {
    ElementaryZoneItem,
  },
  setup() {
    return {
      v: useVuelidate(),
    };
  },
})
export default class ElementaryZoneComponent extends Vue {
  @Prop()
  elementaryZones!: ElementaryZone[];

  @Prop()
  parentValidator!: Validation;

  tooltipHelpelEmentaryZonesTitleSection = this.$sanitize(
    this.$t("help.sitePage.elementaryZonesTitleSection").toString()
  );

  //fields in array
  fields = [
    {
      key: "name",
      label: this.$t("components.sitePage.elementaryZones.fields.name"),
      sortable: true,
      sortIcon: "picto/sort-alpha.svg",
    },
    {
      key: "volume",
      label: this.$t("components.sitePage.elementaryZones.fields.volume"),
      sortable: true,
      sortIcon: "picto/sort-numeric.svg",
    },
    {
      key: "personnelDecontamination",
      label: this.$t("components.sitePage.elementaryZones.fields.personnelDecontamination"),
      sortable: false,
    },
    {
      key: "wasteDecontamination",
      label: this.$t("components.sitePage.elementaryZones.fields.wasteDecontamination"),
      sortable: false,
    },
    {
      key: "extractorsInstallation",
      label: this.$t("components.sitePage.elementaryZones.fields.extractorsInstallation"),
      sortable: false,
    },
  ];

  v!: Validation;

  get maxZoneNumber(): number {
    return store.state.globalAppDataModule.settings.maxZoneNumber;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  sortBy(key: string): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.elementaryZones.sort((a: any, b: any) => {
      return this.compare(a[key], b[key]);
    });
  }

  compare(a: string, b: string): number {
    if (!isNaN(Number(a)) && !isNaN(Number(b))) {
      return Number(a) - Number(b);
    }

    return a.toLowerCase() < b.toLowerCase() ? -1 : a == b ? 0 : 1;
  }

  /**
   * add elementary zone
   */
  add(): void {
    const elementaryZone: ElementaryZone = {
      name: "",
      volume: null,
      wasteDecontamination: this.numberOfZones == 0,
      personnelDecontamination: this.numberOfZones == 0,
      extractorsInstallation: this.numberOfZones == 0,
      minimalDepressionValues: new DepressionCalculatedValues(),
      depressionToMaintainValues: new DepressionCalculatedValues(),
    };
    this.elementaryZones.push(elementaryZone);
  }

  get numberOfZones(): number {
    return this.elementaryZones.length;
  }

  get numberOfFields(): number {
    return this.fields.length;
  }

  // clear elementary zones
  clear(): void {
    this.elementaryZones.splice(0, this.elementaryZones.length);
  }

  deleteElementaryZone(index: number): void {
    this.elementaryZones.splice(index, 1);
  }

  get isPhone(): boolean {
    return !this.$screen.lg;
  }
}
